export const REGISTRATION_TYPE_ID_FIELD_ID = '9a30869b-45fb-46ec-91a9-9b8b9dbe0276';
export const CONTACT_TYPE_ID_FIELD_ID = '2c68a8f4-3ab5-4a83-8ea1-f5739792c825';
export const CONTACT_GROUP_MEMBERSHIP_FIELD_ID = 'cdcda25c-325c-4475-a616-2173ebffb176';
